import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal, TextAreaField, Label } from 'components';
import { isInvestor,  outcomes,isRejectedStatus, isSubmitter, isObjectionCommittee } from 'utils';
import { updateFormField } from 'store/forms/actions';
import { Radio } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { isBeneficiary, isAuditor } from 'utils';

const CancelModal = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  submitDisabled,
  formKey,
  outcome,
  businessKey,
}) => {
  const dispatch = useDispatch();
  const returnAuditorMessage = useSelector(state => state.forms?.carrier?.returnAuditorMessage);
  const user = useSelector(state => state.user);
  const returnAuditor = outcome === outcomes.returnAuditor;


  const submit = (() => {
    setIsVisible(false);
    handleSubmit();
  })

  return (
    <>
    <Modal
      isVisible={isVisible}
      handleCancel={() => {
        setIsVisible(false)
        if (outcome === outcomes.rejectKtp) {
          dispatch(
            updateFormField({
              group: 'carrier',
              key: 'rejectKtpReason',
              value: null,
            })
          )
          dispatch(
            updateFormField({
              group: 'carrier',
              key: "rejectKtpMessage",
              value: null,
            })
          )
        } else if(returnAuditor){
          dispatch(
            updateFormField({
              group: 'carrier',
              key: "returnAuditorMessage",
              value: null,
            })
          )
        }
      }}
      handleConfirm={submit}
      width={
        outcome === outcomes.returnAuditor
          ? 600
          : 400
      }
      cancelText={'Επιστροφή'}
      okText={
         'Ακύρωση'
      }
      submitDisabled={outcome === outcomes.returnAuditor && isEmpty(returnAuditorMessage) }
      formKey={formKey}
      Icon={WarningRed}
      outcome={outcome}
      okButtonClassName={'custom-modal__okCancel-button'}
      user={user}
    >
      <div className="modal-submit-content">
      <div className="content-title font-size-24 mb-2">
          Ακύρωση Αίτησης 
          </div>
        Είστε βέβαιος/-η ότι επιθυμείτε να κάνετε οριστική ακύρωση της αίτησης;
       <br/> Η ενέργεια είναι μη αναστρέψιμη.</div>
    </Modal>
    </>
  );
};

export default CancelModal;
